// Keys para autenticación
export const AUTH_KEYS = {
  all: ["auth"] as const,
  login: () => [...AUTH_KEYS.all, "login"] as const,
  logout: () => [...AUTH_KEYS.all, "logout"] as const,
  profile: () => [...AUTH_KEYS.all, "profile"] as const,
  user: () => [...AUTH_KEYS.all, "user"] as const,
} as const;

// Keys para productos (público)
export const PRODUCT_KEYS = {
  all: ["products"] as const,
  lists: () => [...PRODUCT_KEYS.all, "list"] as const,
  list: (filters: Record<string, unknown>) =>
    [...PRODUCT_KEYS.lists(), filters] as const,
  details: () => [...PRODUCT_KEYS.all, "detail"] as const,
  detail: (id: string) => [...PRODUCT_KEYS.details(), id] as const,
  categories: () => [...PRODUCT_KEYS.all, "categories"] as const,
  search: (query: string) => [...PRODUCT_KEYS.all, "search", query] as const,
  byCategory: (category: string) =>
    [...PRODUCT_KEYS.all, "category", category] as const,
} as const;

// Keys para carrito
export const CART_KEYS = {
  all: ["cart"] as const,
  items: () => [...CART_KEYS.all, "items"] as const,
  summary: () => [...CART_KEYS.all, "summary"] as const,
} as const;

// Keys para pedidos
export const ORDER_KEYS = {
  all: ["orders"] as const,
  lists: () => [...ORDER_KEYS.all, "list"] as const,
  list: (filters: Record<string, unknown>) =>
    [...ORDER_KEYS.lists(), filters] as const,
  details: () => [...ORDER_KEYS.all, "detail"] as const,
  detail: (id: string) => [...ORDER_KEYS.details(), id] as const,
} as const;

// Keys para admin - productos
export const ADMIN_PRODUCT_KEYS = {
  all: ["admin", "products"] as const,
  lists: () => [...ADMIN_PRODUCT_KEYS.all, "list"] as const,
  list: (filters: Record<string, unknown>) =>
    [...ADMIN_PRODUCT_KEYS.lists(), filters] as const,
  details: () => [...ADMIN_PRODUCT_KEYS.all, "detail"] as const,
  detail: (id: string) => [...ADMIN_PRODUCT_KEYS.details(), id] as const,
} as const;

// Keys para admin - categorías
export const ADMIN_CATEGORY_KEYS = {
  all: ["admin", "categories"] as const,
  lists: () => [...ADMIN_CATEGORY_KEYS.all, "list"] as const,
  list: (filters: Record<string, unknown>) =>
    [...ADMIN_CATEGORY_KEYS.lists(), filters] as const,
  details: () => [...ADMIN_CATEGORY_KEYS.all, "detail"] as const,
  detail: (id: string) => [...ADMIN_CATEGORY_KEYS.details(), id] as const,
} as const;

// Keys para admin - pedidos
export const ADMIN_ORDER_KEYS = {
  all: ["admin", "orders"] as const,
  lists: () => [...ADMIN_ORDER_KEYS.all, "list"] as const,
  list: (filters: Record<string, unknown>) =>
    [...ADMIN_ORDER_KEYS.lists(), filters] as const,
  details: () => [...ADMIN_ORDER_KEYS.all, "detail"] as const,
  detail: (id: string) => [...ADMIN_ORDER_KEYS.details(), id] as const,
} as const;

// Keys para admin - dashboard
export const ADMIN_DASHBOARD_KEYS = {
  all: ["admin", "dashboard"] as const,
  stats: () => [...ADMIN_DASHBOARD_KEYS.all, "stats"] as const,
  recentOrders: () => [...ADMIN_DASHBOARD_KEYS.all, "recent-orders"] as const,
  salesChart: () => [...ADMIN_DASHBOARD_KEYS.all, "sales-chart"] as const,
  metrics: (params?: Record<string, unknown>) =>
    [...ADMIN_DASHBOARD_KEYS.all, "metrics", params ?? {}] as const,
} as const;

// Keys para admin - carrusels
export const ADMIN_CAROUSEL_KEYS = {
  all: ["admin", "carousels"] as const,
  lists: () => [...ADMIN_CAROUSEL_KEYS.all, "list"] as const,
  list: (filters: Record<string, unknown>) =>
    [...ADMIN_CAROUSEL_KEYS.lists(), filters] as const,
  details: () => [...ADMIN_CAROUSEL_KEYS.all, "detail"] as const,
  detail: (id: string) => [...ADMIN_CAROUSEL_KEYS.details(), id] as const,
} as const;

// Keys para admin - catálogos
export const ADMIN_CATALOG_KEYS = {
  all: ["admin", "catalogs"] as const,
  lists: () => [...ADMIN_CATALOG_KEYS.all, "list"] as const,
  list: (filters: Record<string, unknown>) =>
    [...ADMIN_CATALOG_KEYS.lists(), filters] as const,
  details: () => [...ADMIN_CATALOG_KEYS.all, "detail"] as const,
  detail: (id: string) => [...ADMIN_CATALOG_KEYS.details(), id] as const,
} as const;

// Keys para admin - quotes
export const ADMIN_QUOTES_KEYS = {
  all: ["admin", "quotes"] as const,
  list: (params?: Record<string, unknown>) =>
    [...ADMIN_QUOTES_KEYS.all, "list", params ?? {}] as const,
} as const;

// Keys para configuración
export const SETTINGS_KEYS = {
  all: ["settings"] as const,
  general: () => [...SETTINGS_KEYS.all, "general"] as const,
} as const;

// Función helper para invalidar múltiples queries
export const invalidateQueries = {
  products: () => PRODUCT_KEYS.all,
  product: (id: string) => [PRODUCT_KEYS.detail(id)],
  cart: () => CART_KEYS.all,
  orders: () => ORDER_KEYS.all,
  adminProducts: () => ADMIN_PRODUCT_KEYS.all,
  adminCategories: () => ADMIN_CATEGORY_KEYS.all,
  adminOrders: () => ADMIN_ORDER_KEYS.all,
  adminCarousels: () => ADMIN_CAROUSEL_KEYS.all,
  adminCatalogs: () => ADMIN_CATALOG_KEYS.all,
  dashboard: () => ADMIN_DASHBOARD_KEYS.all,
  adminQuotes: () => ADMIN_QUOTES_KEYS.all,
} as const;
